import { apiClient } from "../api/ApiClient";
import type { InventoryWareHouse } from "../models/InventoryWareHouse";
import type { KeyValue } from "../models/KeyValue";
import { CreateCrudService } from "./CrudServiceFactory";
export function InventoryWareHouseService() {
  return {
    ...CreateCrudService<InventoryWareHouse, KeyValue>({
      Route: "inventory-warehouse",
      PaginationInPath: true,
      EntityName: "InventoryWareHouse",
      DeleteAction: "DeleteInventoryWareHouse",
      PartialFields: ["Code", "Name"],
      LoadingMessage: "Loading warehouses...",
      SavingMessage: "Saving warehouse...",
      MapPartial: (x) => ({
        Key: String(x.Code ?? ""),
        Value: String(x.Name ?? ""),
      }),
    }),
    GetByCode: async (code: string, signal?: AbortSignal) =>
      (
        await apiClient.get<InventoryWareHouse>(
          `inventory-warehouse/SearchWithCode/${encodeURIComponent(code)}`,
          { signal, showBusyIndicator: false, showError: false },
        )
      ).data,
  };
}
